import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast_position } from "../../Settings/Authorization";
import { toast } from "react-toastify";
import { env } from "../../../../env";
import axiosInstance from "../../../globalInspector/axiosInstance";
import CommonToast from "../../../../components/_utils/CommonToast";
import ICONS from "../../../../assets/Icons";

const baseUrl = env.REACT_APP_BASE_URL;

export const uploadFile = createAsyncThunk(
  "uploadFile",
  async (values, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", values?.file);

      const response = await axiosInstance.post(
        `${baseUrl}/files/upload`,
        formData,
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const uploadStatement = createAsyncThunk(
  "uploadStatement",
  async (statementPayload, { rejectWithValue }) => {
    try {
      const payload = {
        bank_name: statementPayload?.bank_name,
        account_no: statementPayload?.account_no,
        uploaded_file_data: {
          id: statementPayload?.uploaded_file_data?.id,
          storage: "cache",
          metadata: {
            filename: statementPayload?.uploaded_file_data?.metadata?.filename,
            size: statementPayload?.uploaded_file_data?.metadata?.size,
            mime_type:
              statementPayload?.uploaded_file_data?.metadata?.mime_type,
          },
        },
      };

      const sucessData = {
        bank_name: statementPayload?.bank_name,
        account_no: statementPayload?.account_no,
        iFSC_Code: statementPayload?.iFSC_Code,
        Bank_logo: statementPayload?.Bank_logo,
        uploaded_file_data: {
          id: statementPayload?.uploaded_file_data?.id,
          storage: "cache",
          metadata: {
            filename: statementPayload?.uploaded_file_data?.metadata?.filename,
            size: statementPayload?.uploaded_file_data?.metadata?.size,
            mime_type:
              statementPayload?.uploaded_file_data?.metadata?.mime_type,
          },
        },
      };

      sessionStorage.setItem("uploadStatementData", JSON.stringify(sucessData));
      const response = await axiosInstance.post(
        `${baseUrl}/statements/upload`,
        payload,
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const uploadTransactionStatement = createAsyncThunk(
  "uploadTransactionStatement",
  async ({ statementPayload }, { rejectWithValue }) => {
    try {
      const payload = {
        uploaded_file_data: {
          id: statementPayload?.uploaded_file_data?.id,
          storage: "cache",
          metadata: {
            filename: statementPayload?.uploaded_file_data?.metadata?.filename,
            size: statementPayload?.uploaded_file_data?.metadata?.size,
            mime_type:
              statementPayload?.uploaded_file_data?.metadata?.mime_type,
          },
        },

        category: statementPayload?.category,
      };
      sessionStorage.setItem("uploadTxnStatementData", JSON.stringify(payload));

      const response = await axiosInstance.post(
        `${baseUrl}/transactions/upload`,
        payload,
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      sessionStorage.setItem("data", JSON.stringify(error));
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const downloadSampleFile = createAsyncThunk(
  "downloadSampleFile",
  async ({ category }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/sample_file.xlsx`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            category: category,
          },
          responseType: "blob",
        },
      );
      let blob = response.data;

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", `${category}_sample_file.xlsx`);

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      CommonToast({
        text: "Sample file downloaded successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      return true;
    } catch (error) {
      let errorMessage = "Something went wrong";

      try {
        const errorBlob = await error.response.data;
        const text = await errorBlob.text();
        const parsed = JSON.parse(text);

        errorMessage =
          parsed?.error?.base ||
          parsed?.error?.message ||
          parsed?.message ||
          error.message ||
          "Something went wrong";
      } catch (err) {
        errorMessage = error.message || "Something went wrong";
      }
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      return rejectWithValue(errorMessage);
    }
  },
);

export const ownerAccountsViewAll = createAsyncThunk(
  "ownerAccountsViewAll",
  async (values, { rejectWithValue }) => {
    const {
      page_no,
      page_size,
      search_string,
      connected_banking,
      type_of_account,
      bank_account_no,
      ifsc,
      pan,
      bank_name,
      sort_by_balance,
      sort_by,
      tag,
      favourite,
      labels,
    } = values;
    try {
      const response = await axiosInstance.get(`${baseUrl}/accounts/owner`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
        params: {
          "page_no": page_no,
          "page_size": page_size,
          "search_string": search_string,
          "connected_banking": connected_banking,
          "type_of_account": type_of_account,
          "bank_account_no": bank_account_no,
          "ifsc": ifsc,
          "pan": pan,
          "tag": tag,
          "bank_name": bank_name,
          "sort_by_balance[balance]": sort_by_balance
            ? sort_by_balance.includes("Low to high")
              ? "ascending"
              : "descending"
            : undefined,
          "sort_by": sort_by?.length ? sort_by : undefined,
          "favourite": favourite,
          "labels": labels,
        },
      });
      return response.data;
    } catch (error) {
      toast.error(error.response.data.error, toast_position);
      return rejectWithValue(error);
    }
  },
);

export const ownerAccountsDetailsById = createAsyncThunk(
  "ownerAccountsDetailsById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/accounts/owner/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      toast.error(error.response.data.errors.base[0], toast_position);
      return rejectWithValue(error);
    }
  },
);

export const ownerAccountsAddFavourite = createAsyncThunk(
  "ownerAccountsAddFavourite",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/${id}/add_favourite`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      toast.error(error.response.data.errors[0], toast_position);
      return rejectWithValue(error);
    }
  },
);

export const ownerAccountsRemoveFavourite = createAsyncThunk(
  "ownerAccountsRemoveFavourite",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/${id}/remove_favourite`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      toast.error(error.response.data.errors[0], toast_position);
      return rejectWithValue(error);
    }
  },
);

export const updateOwnerDetailsById = createAsyncThunk(
  "updateOwnerDetailsById",
  async (
    { id, type_of_account, od_limit, min_limit, max_limit },
    { rejectWithValue },
  ) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/set_limit/${id}`,
        {
          type_of_account: type_of_account,
          od_limit: od_limit,
          min_limit: min_limit,
          max_limit: max_limit,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      if (error?.response?.data?.errors?.base?.[0]) {
        toast.dismiss();
        CommonToast({
          text: error.response.data.errors.base[0],
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }
      return rejectWithValue(error?.response?.data);
    }
  },
);

export const getOwnerAccStatement = createAsyncThunk(
  "accounts/getOwnerAccStatement",
  async (
    {
      id,
      start_date,
      end_date,
      page_no,
      credit_debit,
      start_amount,
      end_amount,
      page_size,
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/${id}/display_statement`,
        {
          start_date: start_date,
          end_date: end_date,
          page_no: page_no,
          credit_debit: credit_debit,
          start_amount: start_amount,
          end_amount: end_amount,
          page_size: page_size,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      toast.error(error.response.data.errors.base[0], toast_position);
      return rejectWithValue(error);
    }
  },
);

export const getAllOwnerAccStatement = createAsyncThunk(
  "accounts/getAllOwnerAccStatement",
  async (
    {
      id,
      start_date,
      end_date,
      page_no,
      credit_debit,
      credit_amount,
      debit_amount,
      start_amount,
      end_amount,
      page_size,
      bank_name,
      entry_source,
      sort_by,
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/consolidated_statement`,
        {
          start_date: start_date,
          end_date: end_date,
          page_no: page_no,
          credit_debit: credit_debit,
          start_amount: start_amount,
          end_amount: end_amount,
          page_size: page_size,
          owner_account_id: id,
          bank_name,
          credit_amount: credit_amount,
          debit_amount: debit_amount,
          entry_source,
          sort_by,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      if (error?.response?.data?.errors?.user_unauthorized)
        CommonToast({
          text: error?.response?.data?.errors?.user_unauthorized,
          icon: ICONS?.INFO,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      if (error?.response?.data?.errors?.base[0])
        CommonToast({
          text: error?.response?.data?.errors?.base[0],
          icon: ICONS?.INFO,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      return rejectWithValue(error);
    }
  },
);

export const addStatementDescription = createAsyncThunk(
  "accounts/addStatementDescription",
  async ({ id, statement_entry_id, description }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/statement_entry/add_description`,
        {
          id,
          statement_entry_id,
          description,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      if (error?.response?.data?.errors?.user_unauthorized)
        CommonToast({
          text: error?.response?.data?.errors?.user_unauthorized,
          icon: ICONS?.INFO,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      if (error?.response?.data?.errors?.base?.[0])
        CommonToast({
          text: error?.response?.data?.errors?.base?.[0],
          icon: ICONS?.INFO,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      if (error?.response?.data?.errors)
        CommonToast({
          text: error?.response?.data?.errors,
          icon: ICONS?.INFO,
          variant: "var(--error)",
          buttonNeeded: false,
        });

      return rejectWithValue(error);
    }
  },
);

export const addItemizedStatementDescription = createAsyncThunk(
  "accounts/addItemizedStatementDescription",
  async ({ id, statement_entry_id, description }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/itemised_statement_entry/add_description`,
        {
          id,
          statement_entry_id,
          description,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      if (error?.response?.data?.errors?.user_unauthorized)
        CommonToast({
          text: error?.response?.data?.errors?.user_unauthorized,
          icon: ICONS?.INFO,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      if (error?.response?.data?.errors?.base?.[0])
        CommonToast({
          text: error?.response?.data?.errors?.base?.[0],
          icon: ICONS?.INFO,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      if (error?.response?.data?.errors)
        CommonToast({
          text: error?.response?.data?.errors,
          icon: ICONS?.INFO,
          variant: "var(--error)",
          buttonNeeded: false,
        });

      return rejectWithValue(error);
    }
  },
);

export const downloadOwnerStatement = createAsyncThunk(
  "downloadOwnerStatement",
  async ({
    id,
    formatType,
    start_date,
    end_date,
    credit_debit,
    start_amount,
    end_amount,
  }) => {
    const data = {
      start_date,
      end_date,
      credit_debit,
      start_amount,
      end_amount,
    };

    try {
      const response = await fetch(
        `${baseUrl}/accounts/owner/${id}/display_statement_download.${formatType}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          body: JSON.stringify(data),
        },
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }

      // Simple Explanation of the Flow:
      // Get the file as a blob (a raw file).
      // Create a download URL so the browser can access the file.
      // Create a hidden download link.
      // Set the file name (like statement.pdf).
      // Click the link automatically to trigger the download.
      // Clean up by removing the temporary link and URL.

      let blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", `statement.${formatType}`);

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      throw error;
    }
  },
);

export const downloadAllOwnerStatement = createAsyncThunk(
  "downloadAllOwnerStatement",
  async (
    {
      id,
      formatType,
      start_date,
      end_date,
      credit_debit,
      start_amount,
      end_amount,
      bank_name,
      filter_columns,
      entry_source,
    },
    { rejectWithValue },
  ) => {
    const data = {
      owner_account_id: id,
      start_date,
      end_date,
      credit_debit,
      start_amount,
      end_amount,
      bank_name,
      filter_columns,
      entry_source,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/consolidated_statement_download.${formatType}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          responseType: "blob",
        },
      );

      let blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Consolidated Statement [${start_date} to ${end_date}].${formatType}`,
      );

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      let errorMessage = "Something went wrong";

      try {
        const errorBlob = await error.response.data;
        const text = await errorBlob.text();
        const parsed = JSON.parse(text);
        errorMessage =
          parsed?.errors?.errors ||
          parsed?.errors ||
          parsed?.errors?.base?.[0] ||
          parsed?.errors?.token_expired ||
          parsed?.errors?.message ||
          parsed?.message ||
          error.message ||
          "Something went wrong";
      } catch (err) {
        errorMessage = error.message || "Something went wrong";
      }
      CommonToast({
        text: errorMessage,
        icon: ICONS?.INFO,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      return rejectWithValue(error.message);
    }
  },
);

export const getAllOwnerItemisizedReport = createAsyncThunk(
  "accounts/getAllOwnerItemisizedReport",
  async (
    {
      id,
      start_date,
      end_date,
      page_no,
      credit_debit,
      start_amount,
      end_amount,
      credit_amount,
      page_size,
      sort_by,
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/accounts/owner/consolidated_itemised_statement`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            from_date: start_date,
            to_date: end_date,
            page_no: page_no,
            credit_debit: credit_debit,
            min_amount: start_amount,
            max_amount: end_amount,
            page_size: page_size,
            credit_amount: credit_amount,
            owner_account_id: id,
            sort_by: sort_by,
          },
        },
      );
      return response.data;
    } catch (error) {
      CommonToast({
        text: error.response.data.errors.base[0],
        icon: ICONS?.INFO,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      CommonToast({
        text: error?.response?.data?.errors?.user_unauthorized[0],
        icon: ICONS?.INFO,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      return rejectWithValue(error);
    }
  },
);

export const downloadAllItemisizedReport = createAsyncThunk(
  "downloadAllItemisizedReport",
  async (
    {
      id,
      formatType,
      start_date,
      end_date,
      credit_debit,
      start_amount,
      end_amount,
      filter_columns,
    },
    { rejectWithValue },
  ) => {
    const data = {
      owner_account_id: id,
      from_date: start_date,
      to_date: end_date,
      credit_debit,
      min_amount: start_amount,
      max_amount: end_amount,
      filter_columns,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/consolidated_itemised_statement_download.${formatType}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          responseType: "blob",
        },
      );

      let blob = response.data;

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      const startStr = new Date(start_date * 1000).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
      const endStr = new Date(end_date * 1000).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });

      link.setAttribute(
        "download",
        `Live Statement [${startStr} to ${endStr}].${formatType}`,
      );

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      let errorMessage = "Something went wrong";

      try {
        const errorBlob = await error.response.data;
        const text = await errorBlob.text();
        const parsed = JSON.parse(text);
        errorMessage =
          parsed?.errors?.base[0] ||
          parsed?.errors?.token_expired ||
          parsed?.errors?.message ||
          parsed?.message ||
          error.message ||
          "Something went wrong";
      } catch (err) {
        errorMessage = error.message || "Something went wrong";
      }
      CommonToast({
        text: errorMessage,
        icon: ICONS?.INFO,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    }
  },
);

export const ownerAccountsAddTag = createAsyncThunk(
  "accounts/ownerAccountsAddTag",
  async ({ owner_id, tags }, { rejectWithValue }) => {
    const data = {
      owner_id: owner_id,
      tags: tags,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/add_tag`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      toast.error(error.response.data.errors?.base[0], toast_position);
      toast.error(
        error.response.data.errors?.user_unauthorized[0],
        toast_position,
      );
      return rejectWithValue(error);
    }
  },
);
export const ownerAccountsRemoveTag = createAsyncThunk(
  "accounts/ownerAccountsRemoveTag",
  async ({ owner_id, tags }, { rejectWithValue }) => {
    const data = {
      owner_id: owner_id,
      tags: tags,
    };
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/remove_tag`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      if (error.response.data.errors?.base) {
        toast.error(error.response.data.errors?.base[0], toast_position);
      } else {
        toast.error(
          error.response.data.errors?.user_unauthorized[0],
          toast_position,
        );
      }

      return rejectWithValue(error);
    }
  },
);

export const ownerAccountsBalanceRefresh = createAsyncThunk(
  "accounts/ownerAccountsBalanceRefresh",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/${id}/balance`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getCreateTransactionBalance = createAsyncThunk(
  "accounts/getCreateTransactionBalance",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/${id}/balance`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      let errormsg =
        error.response?.data?.errors?.base[0] ||
        error.response?.data?.message ||
        error.response?.data?.error ||
        "An unexpected error occurred.";

      return rejectWithValue(errormsg);
    }
  },
);

export const refreshAllOwnerAccBalance = createAsyncThunk(
  "refreshAllOwnerAccBalance",
  async (id, { rejectWithValue }) => {
    try {
      const response = await fetch(`${baseUrl}/accounts/owner/${id}/balance`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

      return data;
    } catch (error) {
      toast.error(error);
      return rejectWithValue(error);
    }
  },
);
export const getOwnerAccountIFSCDetails = createAsyncThunk(
  "getOwnerAccountIFSCDetails",
  async (values, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/verification/ifsc/` + values?.search_string,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      if (response.data?.errors) {
        toast.error(response.data.errors.base[0], toast_position);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const ownerAccountsHistoricBalanceReport = createAsyncThunk(
  "ownerAccountsHistoricBalanceReport",
  async ({ id, start_date, end_date, interest_rate }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/${id}/historic_balance_report_income`,
        {
          start_date: start_date,
          end_date: end_date,
          investment_percent: 100,
          interest_rate: interest_rate,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const ownerAccountsAddLabel = createAsyncThunk(
  "ownerAccountsAddLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/add_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      const existingLabels = JSON?.parse(
        sessionStorage?.getItem("AvailableLabelsOwner") || [],
      );

      const updatedLabels = Array?.from(
        new Set([...existingLabels, ...labels]),
      );

      const payload = JSON?.stringify(updatedLabels);
      sessionStorage?.setItem("AvailableLabelsOwner", payload);

      return response?.data;
    } catch (error) {
      const apiErrors = error?.response?.data?.errors;

      const message =
        apiErrors?.base?.[0] ||
        apiErrors?.user_unauthorized?.[0] ||
        "Something went wrong";

      toast.dismiss();
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      return rejectWithValue(message);
    }
  },
);

export const ownerAccountsRemoveLabel = createAsyncThunk(
  "ownerAccountsRemoveLabel",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/remove_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response?.data;
    } catch (error) {
      const apiErrors = error?.response?.data?.errors;

      const message =
        apiErrors?.base?.[0] ||
        apiErrors?.user_unauthorized?.[0] ||
        "Something went wrong";

      toast.dismiss();
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      return rejectWithValue(message);
    }
  },
);

const ownerAllVerification = createSlice({
  name: "ownerAllVerification",
  initialState: {
    startDate: null,
    endDate: null,
    toggle: false,
    storedPage: 1,
    ownerAccountAvailableTags: [],
    ownerAccountAvailableLabels: [],

    ownerAccountsAddTagsLoading: true,
    ownerAccountsAddTagsData: [],
    ownerAccountsAddTagsError: false,

    ownerAccountsAddLabelsLoading: true,
    ownerAccountsAddLabelsData: [],
    ownerAccountsAddLabelsError: false,

    ownerAccountsRemoveLabelsLoading: true,
    ownerAccountsRemoveLabelsData: [],
    ownerAccountsRemoveLabelsError: false,

    ownerAccountsAddFavouriteError: null,
    ownerAccountsAddFavouriteDetail: null,
    ownerAccountsAddFavouriteLoading: false,

    ownerAccountsRemoveFavouriteError: null,
    ownerAccountsRemoveFavouriteDetail: null,
    ownerAccountsRemoveFavouriteLoading: false,

    ownerAccountsRemoveTagsLoading: true,
    ownerAccountsRemoveTagsData: [],
    ownerAccountsRemoveTagsError: false,

    ownerViewAllListAccData: null,
    ownerViewAllListAccLoading: null,
    ownerViewAllListAccError: false,
    ownerViewAllListAccErrorData: null,

    uploadStatementLoading: null,
    uploadStatementData: null,
    uploadStatementError: null,

    uploadTransactionStatementLoading: null,
    uploadTransactionStatementData: null,
    uploadTransactionStatementError: null,

    ownerAccountsDetailData: null,
    ownerAccountsDetailLoading: null,
    ownerAccountsDetailError: null,

    ownerAccBalanceLoading: false,
    ownerAccBalanceError: null,
    ownerAllAccBalanceLoading: false,
    ownerAllAccBalanceError: false,
    ownerAccBalanceData: null,
    showSuccessToast: false,

    ownerAccStatementLoading: true,
    ownerAccStatementError: false,
    ownerAccStatementData: null,

    ownerAllAccStatementLoading: false,
    ownerAllAccStatementError: false,
    ownerAllAccStatementData: null,

    ownerAllAccAddDescriptionLoading: false,
    ownerAllAccAddDescriptionError: false,
    ownerAllAccAddDescriptionData: null,

    ownerItemizedAddDescriptionLoading: false,
    ownerItemizedAddDescriptionError: false,
    ownerItemizedAddDescriptionData: null,

    ownerAllAccItemisedLoading: false,
    ownerAllAccItemisedError: false,
    ownerAllAccItemisedData: null,

    createTransactionBankRefreshLoading: null,
    createTransactionBankRefreshData: null,
    createTransactionBankRefreshError: null,

    ownerAccIfscLoading: false,
    ownerAccIfscError: false,
    ownerAccIfscData: null,

    getOwnerAccStatiticsLoading: false,
    getOwnerAccStatiticsError: false,
    getOwnerAccStatiticsData: null,

    getOwnerAccWeekStatiticsLoading: false,
    getOwnerAccWeekStatiticsError: false,
    getOwnerAccWeekStatiticsData: null,

    width: window.innerWidth,
    tokenExpire: false,
  },
  reducers: {
    setStartDate: (state, action) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.endDate = action.payload;
    },
    resetDateRange: (state) => {
      state.startDate = null;
      state.endDate = null;
    },
    setWindowWidth: (state) => {
      state.width = window.innerWidth;
    },
    setshowsuccestoast: (state) => {
      state.showSuccessToast = !state.showSuccessToast;
    },
    setToggle: (state, action) => {
      state.toggle = action.payload;
    },
    setTags: (state, action) => {
      state.ownerAccountAvailableTags = action.payload;
    },
    setOwnerAllAccStatementLoading: (state, action) => {
      state.ownerAllAccStatementLoading = action.payload;
    },
    setOwnerAllAccItemisedLoading: (state, action) => {
      state.ownerAllAccItemisedLoading = action.payload;
    },

    resetpage: (state) => {
      state.storedPage = 1;
    },
    resetToggle: (state) => {
      state.toggle = false;
    },
    setStoredPage: (state, action) => {
      state.storedPage = action.payload;
    },
    resetOwnerBalance: (state) => {
      state.createTransactionBankRefreshError = null;
      state.createTransactionBankRefreshData = null;
    },
    resetLoading: (state) => {
      state.ownerAccBalanceLoading = false;
    },
    resetTokenExpire: (state) => {
      state.tokenExpire = false;
    },
    resetStatementData: (state) => {
      state.ownerAccStatementData = null;
      state.ownerAllAccStatementData = null;
    },
    resetItemisedData: (state) => {
      state.ownerAllAccItemisedData = null;
    },
    setAvailabelLabels: (state, action) => {
      state.ownerAccountAvailableLabels = action.payload;
    },
    updateStatementData: (state, action) => {
      let data = state.ownerAllAccStatementData?.statement?.map((statement) => {
        if (
          statement?.account_statement_entry_id ===
          action?.payload?.account_statement_entry_id
        ) {
          return {
            ...statement,
            description: action?.payload?.description,
          };
        }
        return statement;
      });
      state.ownerAllAccStatementData = {
        ...state.ownerAllAccStatementData,
        statement: data,
      };
    },
    updateItemizedStatementData: (state, action) => {
      let data = state.ownerAllAccItemisedData?.ecollection_callbacks?.map(
        (statement) => {
          if (
            statement?.ecollection_callback_id ===
            action?.payload?.ecollection_callback_id
          ) {
            return {
              ...statement,
              description: action?.payload?.description,
            };
          }
          return statement;
        },
      );
      state.ownerAllAccItemisedData = {
        ...state.ownerAllAccItemisedData,
        ecollection_callbacks: data,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(ownerAccountsAddLabel.pending, (state, action) => {
      state.ownerAccountsAddLabelsLoading = true;
    });
    builder.addCase(ownerAccountsAddLabel.fulfilled, (state, action) => {
      state.ownerAccountsAddLabelsLoading = false;
      state.ownerAccountsAddLabelsData = action.payload;
    });
    builder.addCase(ownerAccountsAddLabel.rejected, (state, action) => {
      state.ownerAccountsAddLabelsLoading = false;
      state.ownerAccountsAddLabelsError = action.payload;
      state.ownerAccountsAddLabelsData = null;
    });
    builder.addCase(ownerAccountsRemoveLabel.pending, (state, action) => {
      state.ownerAccountsRemoveLabelsLoading = true;
    });
    builder.addCase(ownerAccountsRemoveLabel.fulfilled, (state, action) => {
      state.ownerAccountsRemoveLabelsLoading = false;
      state.ownerAccountsRemoveLabelsData = action.payload;
    });
    builder.addCase(ownerAccountsRemoveLabel.rejected, (state, action) => {
      state.ownerAccountsRemoveLabelsLoading = false;
      state.ownerAccountsRemoveLabelsError = action.payload;
      state.ownerAccountsRemoveLabelsData = null;
    });

    builder.addCase(ownerAccountsAddTag.pending, (state, action) => {
      state.tokenExpire = false;
      state.ownerAccountsAddTagsLoading = true;
    });
    builder.addCase(ownerAccountsAddTag.fulfilled, (state, action) => {
      state.tokenExpire = false;
      state.ownerAccountsAddTagsLoading = false;
      state.ownerAccountsAddTagsData = action.payload;
    });
    builder.addCase(ownerAccountsAddTag.rejected, (state, action) => {
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.ownerAccountsAddTagsData = null;
      state.ownerAccountsAddTagsError = action.payload;
      state.ownerAccountsAddTagsLoading = true;
    });

    builder.addCase(uploadStatement.pending, (state) => {
      state.uploadStatementLoading = true;
    });
    builder.addCase(uploadStatement.fulfilled, (state, action) => {
      state.uploadStatementLoading = false;
      state.uploadStatementData = action.payload;
    });
    builder.addCase(uploadStatement.rejected, (state, action) => {
      state.uploadStatementLoading = false;
      state.uploadStatementError = action.payload;
    });

    builder.addCase(uploadTransactionStatement.pending, (state) => {
      state.uploadTransactionStatementLoading = true;
    });
    builder.addCase(uploadTransactionStatement.fulfilled, (state, action) => {
      state.uploadTransactionStatementLoading = false;
      state.uploadTransactionStatementData = action.payload;
    });
    builder.addCase(uploadTransactionStatement.rejected, (state, action) => {
      state.uploadTransactionStatementLoading = false;
      state.uploadTransactionStatementError = action.payload;
    });
    builder.addCase(ownerAccountsRemoveTag.pending, (state, action) => {
      state.tokenExpire = false;
      state.ownerAccountsRemoveTagsLoading = true;
    });
    builder.addCase(ownerAccountsRemoveTag.fulfilled, (state, action) => {
      state.tokenExpire = false;
      state.ownerAccountsRemoveTagsLoading = false;
      state.ownerAccountsRemoveTagsData = action.payload;
    });
    builder.addCase(ownerAccountsRemoveTag.rejected, (state, action) => {
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.ownerAccountsRemoveTagsData = null;
      state.ownerAccountsRemoveTagsError = action.payload;
      state.ownerAccountsRemoveTagsLoading = true;
    });

    builder.addCase(ownerAccountsViewAll.pending, (state, action) => {
      if (action?.payload?.summary?.available_tags) {
        state.ownerAccountAvailableTags = [];
      }
      if (action?.payload?.summary?.available_labels) {
        state.ownerAccountAvailableLabels = [];
      }
      state.tokenExpire = false;
      state.ownerViewAllListAccError = null;
      state.ownerViewAllListAccErrorData = null;
      state.ownerViewAllListAccLoading = true;
    });
    builder.addCase(ownerAccountsViewAll.fulfilled, (state, action) => {
      state.ownerAccountAvailableTags =
        action?.payload?.summary?.available_tags;
      if (action?.payload?.summary?.available_tags) {
        sessionStorage.setItem(
          "AvailableTags",
          JSON.stringify(action?.payload?.summary?.available_tags || []),
        );
      }
      state.ownerAccountAvailableLabels =
        action?.payload?.summary?.available_labels;
      if (action?.payload?.summary?.available_labels) {
        sessionStorage.setItem(
          "AvailableLabelsOwner",
          JSON.stringify(action?.payload?.summary?.available_labels || []),
        );
      }
      state.tokenExpire = false;
      state.ownerViewAllListAccLoading = false;
      state.ownerViewAllListAccData = action.payload;
      state.ownerViewAllListAccError = false;
      state.ownerViewAllListAccErrorData = null;
    });
    builder.addCase(ownerAccountsViewAll.rejected, (state, action) => {
      if (action?.payload?.summary?.available_tags) {
        state.ownerAccountAvailableTags = [];
      }
      if (action?.payload?.summary?.available_labels) {
        state.ownerAccountAvailableLabels = [];
      }
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.ownerViewAllListAccError = true;
      state.ownerViewAllListAccData = null;
      state.ownerViewAllListAccErrorData = action.payload;
    });
    builder.addCase(ownerAccountsDetailsById.pending, (state, action) => {
      state.ownerAccountsDetailLoading = true;
    });
    builder.addCase(ownerAccountsDetailsById.fulfilled, (state, action) => {
      state.ownerAccountsDetailLoading = false;
      state.ownerAccountsDetailData = action.payload;
      state.ownerAccountsDetailError = null;
    });
    builder.addCase(ownerAccountsDetailsById.rejected, (state, action) => {
      state.ownerAccountsDetailError = action.payload;
      state.ownerAccountsDetailData = null;
      state.ownerAccountsDetailLoading = false;
    });
    builder.addCase(ownerAccountsAddFavourite.pending, (state, action) => {
      state.ownerAccountsAddFavouriteLoading = true;
    });
    builder.addCase(ownerAccountsAddFavourite.fulfilled, (state, action) => {
      state.ownerAccountsAddFavouriteError = null;
      state.ownerAccountsAddFavouriteDetail = action?.payload;
      state.ownerAccountsAddFavouriteLoading = false;
    });
    builder.addCase(ownerAccountsAddFavourite.rejected, (state, action) => {
      state.ownerAccountsAddFavouriteError = action.payload;
      state.ownerAccountsAddFavouriteDetail = null;
      state.ownerAccountsAddFavouriteLoading = false;
    });
    builder.addCase(ownerAccountsRemoveFavourite.pending, (state, action) => {
      state.ownerAccountsRemoveFavouriteLoading = true;
    });
    builder.addCase(ownerAccountsRemoveFavourite.fulfilled, (state, action) => {
      state.ownerAccountsRemoveFavouriteError = null;
      state.ownerAccountsRemoveFavouriteDetail = action?.payload;
      state.ownerAccountsRemoveFavouriteLoading = false;
    });
    builder.addCase(ownerAccountsRemoveFavourite.rejected, (state, action) => {
      state.ownerAccountsRemoveFavouriteError = action.payload;
      state.ownerAccountsRemoveFavouriteDetail = null;
      state.ownerAccountsRemoveFavouriteLoading = false;
    });
    builder.addCase(ownerAccountsBalanceRefresh.pending, (state, action) => {
      state.ownerAccBalanceLoading = true;
    });
    builder.addCase(ownerAccountsBalanceRefresh.fulfilled, (state, action) => {
      state.ownerAccBalanceLoading = false;
      state.showSuccessToast = true;
      state.ownerAccBalanceData = action.payload;
    });
    builder.addCase(ownerAccountsBalanceRefresh.rejected, (state, action) => {
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.ownerAccBalanceLoading = false;
      state.ownerAccBalanceError = true;
      state.showSuccessToast = false;
      state.ownerAccBalanceData = null;
    });
    builder.addCase(getCreateTransactionBalance.pending, (state, action) => {
      state.createTransactionBankRefreshLoading = true;
    });
    builder.addCase(getCreateTransactionBalance.fulfilled, (state, action) => {
      state.createTransactionBankRefreshLoading = false;
      state.createTransactionBankRefreshData = action.payload;
    });
    builder.addCase(getCreateTransactionBalance.rejected, (state, action) => {
      state.createTransactionBankRefreshLoading = false;
      state.createTransactionBankRefreshError = action.payload;
      state.createTransactionBankRefreshData = null;
    });
    builder.addCase(refreshAllOwnerAccBalance.pending, (state, action) => {
      state.ownerAllAccBalanceLoading = true;
    });
    builder.addCase(refreshAllOwnerAccBalance.fulfilled, (state, action) => {
      state.ownerAllAccBalanceLoading = false;
    });
    builder.addCase(refreshAllOwnerAccBalance.rejected, (state, action) => {
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.ownerAllAccBalanceError = true;
      state.ownerAllAccBalanceLoading = false;
    });
    builder.addCase(getOwnerAccStatement.pending, (state, action) => {
      state.ownerAccStatementLoading = true;
    });
    builder.addCase(getOwnerAccStatement.fulfilled, (state, action) => {
      state.ownerAccStatementLoading = false;
      state.ownerAccStatementError = false;
      state.ownerAccStatementData = action.payload;
    });
    builder.addCase(getOwnerAccStatement.rejected, (state, action) => {
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.ownerAccStatementData = null;
      state.ownerAccStatementError = true;
      state.ownerAccStatementLoading = false;
    });
    builder.addCase(addStatementDescription.pending, (state, action) => {
      state.ownerAllAccAddDescriptionLoading = true;
    });
    builder.addCase(addStatementDescription.fulfilled, (state, action) => {
      toast.dismiss();
      CommonToast({
        text: "Description updated successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        buttonNeeded: false,
      });
      state.ownerAllAccAddDescriptionLoading = false;
      state.ownerAllAccAddDescriptionError = false;
      state.ownerAllAccAddDescriptionData = action.payload;
    });
    builder.addCase(addStatementDescription.rejected, (state, action) => {
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.ownerAllAccAddDescriptionData = null;
      state.ownerAllAccAddDescriptionError = true;
      state.ownerAllAccAddDescriptionLoading = false;
    });
    builder.addCase(
      addItemizedStatementDescription.pending,
      (state, action) => {
        state.ownerItemizedAddDescriptionLoading = true;
      },
    );
    builder.addCase(
      addItemizedStatementDescription.fulfilled,
      (state, action) => {
        toast.dismiss();
        CommonToast({
          text: "Description updated successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
        state.ownerItemizedAddDescriptionLoading = false;
        state.ownerItemizedAddDescriptionError = false;
        state.ownerItemizedAddDescriptionData = action.payload;
      },
    );
    builder.addCase(
      addItemizedStatementDescription.rejected,
      (state, action) => {
        if (action?.payload?.response?.data?.errors?.token_expired) {
          state.tokenExpire = true;
        }
        state.ownerItemizedAddDescriptionData = null;
        state.ownerItemizedAddDescriptionError = true;
        state.ownerItemizedAddDescriptionLoading = false;
      },
    );
    builder.addCase(getAllOwnerAccStatement.pending, (state, action) => {
      state.ownerAllAccStatementLoading = true;
    });
    builder.addCase(getAllOwnerAccStatement.fulfilled, (state, action) => {
      state.ownerAllAccStatementLoading = false;
      state.ownerAllAccStatementError = false;
      state.ownerAllAccStatementData = action.payload;
    });
    builder.addCase(getAllOwnerAccStatement.rejected, (state, action) => {
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.ownerAllAccStatementData = null;
      state.ownerAllAccStatementError = true;
      state.ownerAllAccStatementLoading = false;
    });
    builder.addCase(getAllOwnerItemisizedReport.pending, (state, action) => {
      CommonToast({
        text: "Fetching live statement",
        icon: ICONS?.LOADER_GIF,
        variant: "var(--processing)",
        buttonNeeded: false,
      });

      state.ownerAllAccItemisedLoading = true;
    });
    builder.addCase(getAllOwnerItemisizedReport.fulfilled, (state, action) => {
      toast.dismiss();
      CommonToast({
        text: "Live statement fetched successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        buttonNeeded: false,
      });
      state.ownerAllAccItemisedLoading = false;
      state.ownerAllAccItemisedError = false;
      state.ownerAllAccItemisedData = action.payload;
    });
    builder.addCase(getAllOwnerItemisizedReport.rejected, (state, action) => {
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.ownerAllAccItemisedData = null;
      state.ownerAllAccItemisedError = true;
      state.ownerAllAccItemisedLoading = false;
    });

    builder.addCase(downloadOwnerStatement.pending, (state, action) => {
      state.ownerAccStatementDownloadLoading = true;
    });
    builder.addCase(downloadOwnerStatement.fulfilled, (state, action) => {
      state.ownerAccStatementDownloadLoading = false;
      state.ownerAccStatementDownloadStatus = action.payload;
    });

    builder.addCase(downloadOwnerStatement.rejected, (state, action) => {
      state.ownerAccStatementDownloadLoading = false;
      state.ownerAccStatementDownloadError = action.payload;
    });
    builder.addCase(downloadSampleFile.pending, (state, action) => {
      state.downloadSampleFileLoading = true;
    });
    builder.addCase(downloadSampleFile.fulfilled, (state, action) => {
      state.downloadSampleFileLoading = false;
      state.downloadSampleFileStatus = action.payload;
    });

    builder.addCase(downloadSampleFile.rejected, (state, action) => {
      state.downloadSampleFileLoading = false;
      state.downloadSampleFileError = action.payload;
    });

    builder.addCase(getOwnerAccountIFSCDetails.pending, (state, action) => {
      state.ownerAccIfscLoading = true;
      state.ownerAccIfscError = false;
    });
    builder.addCase(getOwnerAccountIFSCDetails.fulfilled, (state, action) => {
      state.ownerAccIfscLoading = false;
      state.ownerAccIfscData = action.payload;
    });
    builder.addCase(getOwnerAccountIFSCDetails.rejected, (state, action) => {
      state.ownerAccIfscError = true;
      state.ownerAccIfscLoading = false;
    });
    builder.addCase(
      ownerAccountsHistoricBalanceReport.pending,
      (state, action) => {
        state.getOwnerAccStatiticsError = null;
        state.getOwnerAccStatiticsLoading = true;
      },
    );
    builder.addCase(
      ownerAccountsHistoricBalanceReport.fulfilled,
      (state, action) => {
        state.getOwnerAccStatiticsLoading = false;
        state.getOwnerAccStatiticsData = action.payload;
      },
    );
    builder.addCase(
      ownerAccountsHistoricBalanceReport.rejected,
      (state, action) => {
        state.getOwnerAccStatiticsError = true;
        state.getOwnerAccStatiticsLoading = false;
      },
    );
  },
});

export const {
  setWindowWidth,
  setshowsuccestoast,
  setToggle,
  resetpage,
  setStoredPage,
  resetOwnerBalance,
  resetLoading,
  resetTokenExpire,
  resetToggle,
  setTags,
  resetStatementData,
  setOwnerAllAccStatementLoading,
  uploadStatementLoading,
  uploadTransactionStatementError,
  resetLabelOwnerLoading,
  resetItemisedData,
  setOwnerAllAccItemisedLoading,
  updateStatementData,
  updateItemizedStatementData,
  setStartDate,
  setEndDate,
  resetDateRange,
} = ownerAllVerification.actions;

export default ownerAllVerification.reducer;
